import {
  ButtonNormalPrimarySmall,
  ButtonWrapper,
} from '@angeplus/prever-component-lib';

import { useRedirectToContractDraft } from '../../utils/useRedirectToContractDraft';

type PlanVersionAngeplusButtonProps = {
  planVersionId: string;
};

export const PlanVersionAngeplusButton = (
  props: PlanVersionAngeplusButtonProps,
) => {
  const { redirectToContractDraft, isLoading } = useRedirectToContractDraft(
    props.planVersionId,
  );

  return (
    <ButtonWrapper onClick={redirectToContractDraft} isLoading={isLoading}>
      <ButtonNormalPrimarySmall isLoading={isLoading}>
        Adquirir este plano
      </ButtonNormalPrimarySmall>
    </ButtonWrapper>
  );
};
